/* eslint-disable max-len */
import * as React from 'react';
import { IconProps } from '../../common/types/componentTypes';

const CheckIconBold: React.FC<IconProps> = ({ width = 24, height = 24, color = '#717887', ...props }) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M18.7713 6L8.95885 15.5967L5.22868 11.9485L4 13.1502L8.95885 18L20 7.20166L18.7713 6Z" fill={color} />
    </svg>
);

export default CheckIconBold;
